import React from "react";
import AdminLayout from "../../components/AdminLayout";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { WarningFilled } from "@ant-design/icons";

const Error: React.FC = () => {
  const navigate = useNavigate();
  return (
    <AdminLayout children={
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        padding: '20px'
      }}>
        <div className="error-container" style={{ 
          textAlign: 'center', 
          padding: '60px 40px', 
          backgroundColor: '#ffffff',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          width: '100%',
          maxWidth: '480px',
          border: '1px solid #f0f0f0'
        }}>
          <WarningFilled style={{ 
            fontSize: '72px', 
            color: '#faad14', 
            marginBottom: '24px',
            display: 'block'
          }} />
          <h1 className="error-title" style={{
            fontSize: '24px',
            fontWeight: '600',
            color: '#262626',
            marginBottom: '16px',
            lineHeight: '1.4'
          }}>
            คุณไม่มีสิทธิ์เข้าถึงหน้านี้
          </h1>
          <p className="error-message" style={{
            fontSize: '16px',
            color: '#8c8c8c',
            marginBottom: '32px',
            lineHeight: '1.5',
            maxWidth: '360px',
            margin: '0 auto 32px auto'
          }}>
            โปรดติดต่อผู้ดูแลระบบหากต้องการสิทธิ์ในการจัดการเนื้อหา
          </p>
          <Button
            type="primary"
            size="large"
            onClick={() => navigate('/')}
            style={{
              borderRadius: '6px',
              fontWeight: '500',
              height: '44px',
              paddingLeft: '32px',
              paddingRight: '32px',
              fontSize: '16px'
            }}
          >
            กลับหน้าหลัก
          </Button>
        </div>
      </div>
    }>
    </AdminLayout>
  );
};

export default Error;
